/* eslint-disable indent */
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";

import ReactHTMLTableToExcel from "react-html-table-to-excel";

import { loginTypeConstant } from "../../../constant/loginType/loginTypeConstant";
import TopInput from "./TopInput";
import {
  attendanceActions,
  locationActions
} from "../../../redux/actions";
import AttendanceUserList from "./AttendanceUserList";
import { AttendanceTypes } from "../../../redux/type/type";
import { helperFunction } from "../../../constant/helper";
import moment from "moment";
import {
  // isWeekend,
  renderDate,
  // renderShift,
  totalDynamicPAH,
  TimeStampIntoHours
} from "../../../constant/helper/helper";
import Starter from "../../../component/Starter";
import isEmpty from "../../../validation/isEmpty";

const initialState = {
  Filter: "",
  toDate: "",
  fromDate: "",
  locationId: "",
  dataType: "ABSENT",
  dataRange: 1
};

const CREATED_AS_TYPE2 = {
  leave: "LEAVE",
  absent: "ABSENT",
  holiday: "HOLIDAY",
  halfTime: "HALF_TIME",
  fullTime: "FULL_TIME",
  earlyOut: "EARLY_OUT",
  overTime: "OVER_TIME",
  weeklyOff: "WO",
  lateComing: "LATE_COMING",
  outDoorDuty: "OUTDOOR_DUTY"
};

const DynamicAttendanceSheet = () => {
  const componentRef = useRef();

  const loginType = localStorage.loginType;

  const dispatch = useDispatch();
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);
  const [dateDifference, setDateDifference] = useState(0);
  const [dateArrayState, setDateArrayState] = useState([]);
  const [sheetAttendanceData, setSheetAttendanceData] = useState([]);

  const { locations } = useSelector((state) => state.location);
  const { currentUser } = useSelector((state) => state.auth);
  const {
    toDate,
    fromDate,
    dataRange,
    locationId,
    attendanceError,
    attendanceLoading,
    attendanceDynamicSheetData
  } = useSelector((state) => state.attendance);

  // show face type option
  const showDataTypeOptions = Object.values(CREATED_AS_TYPE2).map(
    (type, index) => (
      <option value={type} key={index}>
        {type}
      </option>
    )
  );

  useEffect(() => {
    if (attendanceDynamicSheetData) {
      setSheetAttendanceData(
        attendanceDynamicSheetData.map((sheet) => {
          const dailyPointsArrayState = [];
          const dailyPoints = [];
          sheet.attendances.map((date) => {
            return dailyPointsArrayState.push({
              Date: moment(date.Date).format("DD/MM/yyyy"),
              createdAs: date.createdAs,
              lateTime: date.lateTime,
              earlyOutTime: date.earlyOutTime,
              overTime: date.overTime,
              duration: date.duration,
              inTime: TimeStampIntoHours(date?.inTime),
              outTime: TimeStampIntoHours(date?.outTime)
            });
          });

          const obj = _.mapKeys(dailyPointsArrayState, "Date");
          dateArrayState.forEach((dateValue) => {
            const createdAsToInsert = isEmpty(obj[dateValue])
              ? null
              : obj[dateValue].createdAs;
            const lateTime = isEmpty(obj[dateValue])
              ? null
              : obj[dateValue].lateTime;
            const earlyOutTime = isEmpty(obj[dateValue])
              ? null
              : obj[dateValue].earlyOutTime;
            const overTime = isEmpty(obj[dateValue])
              ? null
              : obj[dateValue].overTime;
            const inTime = isEmpty(obj[dateValue])
              ? null
              : obj[dateValue].inTime;
            const outTime = isEmpty(obj[dateValue])
              ? null
              : obj[dateValue].outTime;
            const duration = isEmpty(obj[dateValue])
              ? null
              : obj[dateValue].duration;
            // const inCreatedAsToInsert = isEmpty(obj[dateValue])
            //   ? null
            //   : obj[dateValue].inCreatedAs;
            // const outCreatedAsToInsert = isEmpty(obj[dateValue])
            //   ? null
            //   : obj[dateValue].outCreatedAs;

            return dailyPoints.push({
              Date: dateValue,
              createdAs: createdAsToInsert,
              lateTime,
              earlyOutTime,
              overTime,
              inTime,
              outTime,
              duration
              // isEmpty(inCreatedAsToInsert) &&
              // isEmpty(outCreatedAsToInsert)
              //   ? createdAsToInsert
              //   : renderShift(
              //       isEmpty(inCreatedAsToInsert)
              //         ? "-"
              //         : inCreatedAsToInsert,
              //       isEmpty(outCreatedAsToInsert)
              //         ? "-"
              //         : outCreatedAsToInsert
              //     )
            });
          });
          const { totalValue } = totalDynamicPAH(
            dailyPoints,
            values.dataType
          );
          return {
            Location: sheet.locationName,
            workerId: sheet.workerId,
            dailyPointsArray: dailyPoints,
            employeeId: sheet._id,
            total_duration: 0,
            totalValue: totalValue,
            totalDays: !isEmpty(dateArrayState)
              ? dateArrayState.length
              : 0,
            workerFullName:
              sheet.workerFirstName + " " + sheet.workerSurname,
            workerDepartment: sheet.workerDepartment,
            workerDesignation: sheet.workerDesignation
          };
        })
      );
    }
  }, [attendanceDynamicSheetData]);

  useEffect(() => {
    if (attendanceError) {
      helperFunction.toastHelper("error", attendanceError);
    }
  }, [attendanceError]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    setValues({
      ...values,
      fromDate,
      toDate,
      locationId,
      dataRange
    });
  }, [fromDate, toDate, locationId, dataRange]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());
    // dispatch(locationActions.getAllLocation(loginType));
    return () => {
      dispatch(locationActions.clearLocationErrors());
      dispatch(locationActions.clearLocationResult());
    };
  }, []);

  // fetch attendance
  const fetchAttendanceSheet = (e) => {
    e.preventDefault();
    const {
      fromDate,
      toDate,
      locationId,
      dataType,
      dataRange
    } = values;
    if (fromDate === "" || toDate === "") {
      const errorData = {
        data: {
          message: "From Date,To Date or Location is not selected"
        },
        status: 400
      };
      return dispatch({
        type: AttendanceTypes.ATTENDANCE_GET_ERRORS,
        payload: errorData
      });
    } else {
      const diffTime = Math.abs(
        new Date(toDate) - new Date(fromDate)
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setDateDifference(diffDays);
      const dateArray = renderDate(values);
      setDateArrayState(dateArray);
      dispatch(attendanceActions.setAttendanceLoading(true));
      dispatch(attendanceActions.clearAttendanceErrors());
      dispatch(attendanceActions.clearAttendanceResult());

      dispatch(
        attendanceActions.getDynamicAttendanceSheet(
          fromDate,
          toDate,
          locationId,
          loginType,
          dataType,
          dataRange
        )
      );
    }
  };

  return (
    <Starter
      topBarTitle="Reports Attendance"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Attendance Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Attendance</a>
          </li>
          <li className="breadcrumb-item active">Attendance</li>
        </Fragment>
      }
    >
      <TopInput
        values={values}
        currentUser={currentUser}
        loading={attendanceLoading}
        onChange={handleInputChange}
        onSubmit={fetchAttendanceSheet}
        showDataTypeOptions={showDataTypeOptions}
        allLocations={
          typeof allLocations !== "undefined" &&
          allLocations.length > 0
            ? allLocations
            : []
        }
      />
      <AttendanceUserList
        values={values}
        loginType={loginType}
        excelRef={componentRef}
        loading={attendanceLoading}
        dateDifference={dateDifference}
        dateArrayState={dateArrayState}
        loginTypeConstant={loginTypeConstant}
        setDateArrayState={setDateArrayState}
        attendanceSheetData={sheetAttendanceData}
      />
      <div className="row mt-3">
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
        <div className="col-2">
          <ReactHTMLTableToExcel
            sheet="Sheet"
            buttonText="Export excel"
            table="products-datatable"
            className="btn btn-dark btn-block"
            filename={`${fromDate}_${toDate}`}
          />
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
      </div>
    </Starter>
  );
};

export default DynamicAttendanceSheet;
